/**
 * 접속한 기기의 PC 여부 확인
 */
// eslint-disable-next-line import/prefer-default-export
export const checkPCMixin = {
  data() {
    return {
      isPC: false,
    };
  },
  created() {
    const filter = 'win16|win32|win64|mac|macintel';
    // check PC
    this.isPC = (navigator.platform && filter.indexOf(navigator.platform.toLowerCase()) >= 0);
  },
};
